export default __webpack_public_path__ + "static/media/CountCouple_01.67444015.png";